import { createAsyncThunk } from "@reduxjs/toolkit";
import { Situacoes } from "model/solicitacao/Situacao";
import { ApiSolicitacoes, SolicitacoesQueryParams } from "service/api/solicitacao/ApiSolicitacoes";
import { RootState } from "store/store";
import { ErrosUtils } from "util/ErrosUtils";
import { OrdemColunaTabela } from "view/component/Tabela/model/OrdemColunaTabela";


export type TipoAcaoListaSolicitacao = 
  | 'novaBusca'
  | 'carregarPagina'
  ;

type ListaSolicitacaoType = {
    queryParams?: SolicitacoesQueryParams;
    preservarOrdem: boolean;
    ordem?: OrdemColunaTabela;
    acao: TipoAcaoListaSolicitacao;
    pagina?: number;
}

class ListaSolicitacaoAction {

    static readonly iniciarMinhasSolicitacoes = (idUsuarioLogado: string) => {
        return ListaSolicitacaoAction.iniciar({idSolicitante: [idUsuarioLogado]});
    }

    static readonly iniciarUnidadesDoReino = (idUnidade?: number) => {
        if (idUnidade === undefined) {
            return;
        }
        
        return ListaSolicitacaoAction.iniciar({
            idSituacao: Situacoes.getAllOnListIdNivel1(),
            idUnidadeResponsavel: [idUnidade ?? 0]
        });
    }

    static readonly iniciar = (queryParams?: SolicitacoesQueryParams, ordem?: OrdemColunaTabela) => {
        return ListaSolicitacaoAction._carregar({acao: 'novaBusca', pagina: 1, queryParams: queryParams, ordem: ordem, preservarOrdem: true });
    }

    static readonly alterarOrdem = (ordem?: OrdemColunaTabela) => {
        return ListaSolicitacaoAction._carregar({acao: 'carregarPagina', ordem: ordem, preservarOrdem: false})
    }
    
    static readonly carregarPagina = (pagina: number) => {
        return ListaSolicitacaoAction._carregar({acao: 'carregarPagina', pagina: pagina, preservarOrdem: true});
    }

    static readonly _carregar = createAsyncThunk(
        'Solicitacoes/lista/carregar',
        async ({queryParams, pagina, ordem, preservarOrdem}: ListaSolicitacaoType, {getState, rejectWithValue}) => {
            const { solicitacoes } = getState() as RootState;

            const queryParamsConsulta = queryParams ?? solicitacoes.filtros;
            const ordemColunaTabela = ordem !== undefined || (ordem === undefined && !preservarOrdem)
                ? ordem
                : solicitacoes.ordem;
            const paginaConsulta = pagina ?? solicitacoes.pagina.atual+1;

            try {
                return await ApiSolicitacoes.getSolicitacoes(paginaConsulta, ordemColunaTabela, queryParamsConsulta);
            } catch (e) {
                return rejectWithValue(ErrosUtils.converterErroAxiosParaErroSistema(e))
            }
        }

    )
}

export class SolicitacoesAction {
    public static readonly lista = ListaSolicitacaoAction;
}